import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DAO from '../dao/DAO';
import AdminPortalDropdown from './AdminPortalDropdown';
import { HEIGHT, WEIGHT } from './ConsumerAccountProperties';

class EnterpriseAccountProperties extends Component {

  static contextTypes = {
    dao: PropTypes.instanceOf(DAO),
    ngUser: PropTypes.object,
    onError: PropTypes.func,
    onSuccess: PropTypes.func,
  };

  static propTypes = {
    accountProperties: PropTypes.array,
    isEditing: PropTypes.bool.isRequired,
  }

  state = {
    newWeightUnit: '',
    newHeightUnit: '',
  }

  componentDidMount() {
    this.updateStateProperties(this.props);
  }

  componentWillReceiveProps(nextProps: Readonly<P>, nextContext: any) {
    const { isEditing, enableEditMode, onSave } = this.props;
    const { onError } = this.context;
    if (isEditing === false && nextProps.isEditing === true) {
      if (this.requiredFieldsCompletedCheck()) {
        const account = this.bundleAccount();
        this.setState({ newWeightUnit: '', newHeightUnit: '' }, onSave(account));
      } else {
        onError('Please fill in the required fields.');
        enableEditMode();
      }
    } else {
      this.updateStateProperties(nextProps);
    }
  }

  updateStateProperties(props) {
    const newWeightUnit = this.fetchAccountProperty(props, 'weight_unit') === '' ? 'pounds' :
      this.fetchAccountProperty(props, 'weight_unit');
    const newHeightUnit = this.fetchAccountProperty(props, 'height_unit') === '' ? 'inches' :
      this.fetchAccountProperty(props, 'height_unit');
    this.setState({
      newWeightUnit,
      newHeightUnit,
    });
  }

  bundleAccount() {
    const { newWeightUnit, newHeightUnit } = this.state;
    return {
      ...this.props.accountSummary,
      height_unit: newHeightUnit,
      weight_unit: newWeightUnit,
    };
  }

  requiredFieldsCompletedCheck() {
    const { newWeightUnit, newHeightUnit } = this.state;
    return !(newWeightUnit === '' || newHeightUnit === '');
  }

  handleSelectedDropdown = (e) => {
    this.setState({
      [ e.target.name ]: e.target.value
    });
  }

  fetchAccountProperty(props, key) {
    const { accountSummary } = props;
    if (accountSummary !== undefined) {
      const property = accountSummary[ key ];
      return property || '';
    } else {
      return '';
    }
  }

  render() {
    const { isEditing } = this.props;
    const { newWeightUnit, newHeightUnit } = this.state;
    return (
      <div className="full-width">
        <div className="display-flex full-width mg-md">
          <div style={{ width: '32%', marginRight: 20 }}>
            <AdminPortalDropdown
              options={HEIGHT}
              defaultValue={newHeightUnit}
              value={newHeightUnit}
              label={'Height'}
              helperText={'Enter Height.'}
              id={'newHeightUnit'}
              disabled={isEditing}
              handleSelectedDropdown={this.handleSelectedDropdown}
              error={newHeightUnit === ''}
              isRequired={true}
            />
          </div>
          <div style={{ width: '32%', marginRight: 20 }}>
            <AdminPortalDropdown
              options={WEIGHT}
              defaultValue={newWeightUnit}
              value={newWeightUnit}
              label={'Weight'}
              helperText={'Enter Weight.'}
              id={'newWeightUnit'}
              disabled={isEditing}
              handleSelectedDropdown={this.handleSelectedDropdown}
              error={newWeightUnit === ''}
              isRequired={true}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(EnterpriseAccountProperties);